import React from 'react';
import {
  IconCheckmarkCircle,
  IconGear,
  IconMinusCircle,
  IconWarning,
} from '@veneer/core';
import { printerStatus } from '@jarvis/react-portal-addons';

export const StateSeverity = {
  NONE: 0,
  REPORT: 1,
  WARNING: 2,
  ERROR: 3,
};

export function severityToIcon(severity) {
  switch (severity) {
    case StateSeverity.NONE:
      return (
        <IconCheckmarkCircle
          size={24}
          filled
          color="green6"
        />
      );
    case StateSeverity.REPORT:
      return (
        <IconGear
          size={24}
          filled
          color="hpBlue6"
        />
      );
    case StateSeverity.WARNING:
      return (
        <IconWarning
          size={24}
          filled
          color="darkOrange6"
        />
      );
    case StateSeverity.ERROR:
      return (
        <IconMinusCircle
          size={24}
          filled
          color="red6"
        />
      );
    default:
      return null;
  }
}

export function severityToString(severity) {
  switch (severity) {
    case StateSeverity.NONE:
      return 'Ready to Print';
    case StateSeverity.REPORT:
      return 'Finish Printer Setup';
    case StateSeverity.WARNING:
      return 'Needs Attention';
    case StateSeverity.ERROR:
      return 'Unable to Print';
    default:
      return null;
  }
}

export const ConnectionState = {
  OFFLINE: 0,
  ONLINE: 1,
};

export function connectionStateToString(connectionState) {
  switch (connectionState) {
    case ConnectionState.OFFLINE:
      return 'Not Connected';
    case ConnectionState.ONLINE:
      return 'Connected';
    default:
      return null;
  }
}

export const PRINTER_STATUS = [
  {
    id: 'ready',
    title: 'status.header.devices.ready',
    color: 'green6',
    filled: true,
  },
  {
    id: 'error',
    title: 'status.header.devices.error',
    color: 'red6',
    filled: true,
  },
  {
    id: 'warning',
    title: 'status.header.devices.warning',
    color: 'orange6',
    filled: true,
  },
  {
    id: 'unknown',
    title: 'status.header.devices.unknown',
    color: 'powerStorm5',
    filled: true,
  },
  {
    id: 'connected',
    title: 'status.header.devices.connected',
    color: 'electricBlue7',
    filled: true,
  },
  {
    id: 'offline',
    title: 'status.header.devices.offline',
    color: 'gray6',
    filled: false,
  },
];

export function getDeviceStatusCounts(devices) {
  return devices.reduce((counts, device) => {
    const status = printerStatus.getPrinterStatus({ printerInfo: device });

    return {
      ...counts,
      totalDevices: counts.totalDevices + 1,
      [status]: (counts[status] || 0) + 1,
    };
  }, {
    totalDevices: 0,
    ready: 0,
    error: 0,
    warning: 0,
    unknown: 0,
    connected: 0,
    offline: 0,
  });
}

export const DASHBOARD_ENTITLEMENTS = {
  smartSecurity: 'ws-hp.com/smartsecurity',
  printAnywhere: 'ws-hp.com/potg',
  forestFirst: 'ws-hp.com/positiveprinting',
  printPlans: 'ws-hp.com/printplans',
  instantInk: 'ws-hp.com/instantink',
};
